import { LookupResponse } from "../interfaces/response/LookupResponse";
import { Option } from "../interfaces/Option";
import dataService from "../services/dataService";
import fetchLookupOptionsPayload from "../interfaces/payload/FetchLookupOptionsPayload";

class FetchLookupOptionsHelper {
  static async fetchLookupOptions(
    payload: fetchLookupOptionsPayload
  ): Promise<LookupResponse<Option>> {
    const result = await dataService.fetchLookupOptionsRaw(payload);

    if (!result.success) {
      throw new Error("Lookup failed");
    }

    const items = result.data?.items ?? [];
    const hasMore = items.length === payload.pageSize;

    return {
      items,
      hasMore,
      nextPage: hasMore ? payload.page + 1 : null,
    };
  }
}

export default FetchLookupOptionsHelper;
